import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AgentDetailsHeader from '../../Components/Agent/AgentDetailsHeader';
import TermAgentNav from '../../Components/Agent/TermAgentNav';
import AgentStatementsSection from '../../Components/Agent/AgentStatementsSection';
import Agent1099Section from '../../Components/Agent/Agent1099Section';
import { useAuth } from "../../src/Context/AuthContext";


const AgentDetailsPage = () => {
    //State Variables 
    const { agtCode } = useParams();
    const [activeSection, setActiveSection] = useState('agent-statements-container');
    const [model, setModel] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { logout } = useAuth();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - ${agtCode}`;

    useEffect(() => {
        const fetchAgent = async () => {
            try {
                const res = await fetch(`${apiURL}/Agent/GetTerminatedAgent?agtCode=${agtCode}`, {
                    method: 'GET',
                    credentials: 'include'
                });

                if (res.status === 401) {
                    logout();
                    navigate('/login');
                    throw new Error("unauthorized");
                }

                if (res.status === 403) {
                    navigate('/home');
                    throw new Error("forbidden");
                }

                if (!res.ok) {
                    return;
                }
                const data = await res.json();
                setModel(data);
            } catch (error) {
                console.error('Error fetching agent:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAgent();
    }, [agtCode]);

    const handleNavClick = (section) => {
        setActiveSection(section);
        setTimeout(() => {
            const sectionElement = document.getElementById(section);
            if (sectionElement) {
                sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100); // slight delay to ensure DOM is updated
    };

    if (loading) return <div></div>;
    if (!model) return <div className="text-center mt-5 text-danger">Agent not found.</div>;

    return (
        <div className="PolicyDetailsPage">
            <AgentDetailsHeader agtCode={model.agtCode} />
            <TermAgentNav
                model={model}
                selectedSection={activeSection}
                onNavClick={handleNavClick}
            />

            {activeSection === 'agent-statements-container' && <AgentStatementsSection model={model} />}
            {activeSection === 'agent-1099-container' && <Agent1099Section model={model} />}
        </div>
    );
};

export default AgentDetailsPage;
